import {
    Component,
    computed,
    input,
    InputSignal,
    model,
    ModelSignal,
    resource,
    ResourceRef,
    Signal,
} from '@angular/core';
import { AppealRecommendationRepository } from '../../appealRecommendation.repository';
import { MultiTypeaheadComponent } from '../../../UI-Lib/Typeahead/Multi-Typeahead/multiTypeahead.component';
import { AppealRecommendationTemplateModalService } from '../appealRecommendationTemplateModal.service';

@Component({
    selector: 'multi-user-picker',
    template: `
        <multi-typeahead
            [availableItems]="availableRecipients()"
            [(selectedItems)]="selectedUsers"
            [isReadonly]="isReadonly()"
            placeholder="Search users..."
            valueIdProp="value"
            displayNameProp="name"
        >
        </multi-typeahead>
    `,
    imports: [MultiTypeaheadComponent],
})
export class MultiUserPickerComponent {
    constructor(
        private readonly _appealRecommendationRepository: AppealRecommendationRepository,
        private readonly _appealRecommendationTemplateModalService: AppealRecommendationTemplateModalService,
    ) {}

    selectedUsers: ModelSignal<Compliance.NameValuePair<number>[]> = model();
    taskIds: InputSignal<number[]> = input();
    isReadonly: InputSignal<boolean> = input();
    isTo: InputSignal<boolean> = input();

    availableRecipients: Signal<Compliance.NameValuePair<number>[]> = computed(() => {
        this._availableRecipients = this.availableRecipientsRef.value();
        if (!this._availableRecipients) {
            return;
        }
        return this.taskIds() ? this._availableRecipients?.map((x) => ({ name: x.name, value: x.contactId })) : [];
    });

    availableRecipientsRef: ResourceRef<Core.AppealRecipientModel[]> = resource({
        loader: () => this._appealRecommendationTemplateModalService.getAvailableRecipients(this.taskIds()),
    });

    private _availableRecipients: Core.AppealRecipientModel[] | null = null;
}
